import { useState } from "react";

import { useAuth } from "@/auth/useAuth";
import { useMe } from "@/hooks/useMe";

import "./UserAvatarMenu.css";

export function UserAvatarMenu(): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const { firebaseUser, signOutUser } = useAuth();
  const { me } = useMe();

  const displayName =
    me?.display_name?.split(/\s+/)[0] ??
    firebaseUser?.email?.split("@")[0] ??
    "User";

  const initials = displayName.charAt(0).toUpperCase();

  const handleLogout = async (): Promise<void> => {
    await signOutUser();
    setIsOpen(false);
  };

  return (
    <div className="user-avatar-menu">
      <button
        type="button"
        className="avatar-button"
        onClick={(): void => {
          setIsOpen((prev) => !prev);
        }}
        aria-label={`${displayName}'s avatar menu`}
        aria-expanded={isOpen}
      >
        {initials}
      </button>

      {isOpen && (
        <div className="avatar-dropdown" role="menu">
          <div className="avatar-dropdown-header">
            <div className="avatar-initials-large">{initials}</div>
            <div className="user-name">{displayName}</div>
          </div>
          <div className="avatar-dropdown-items">
            <button
              type="button"
              role="menuitem"
              className="dropdown-item"
              disabled
            >
              My Profile <span className="coming-soon">Coming Soon</span>
            </button>
            <button
              type="button"
              role="menuitem"
              className="dropdown-item"
              onClick={(): void => {
                void handleLogout();
              }}
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
